export default __webpack_public_path__ + "static/media/fspo.405bdfbe.jpg";